import { render, staticRenderFns } from "./PlanCaseDetail.vue?vue&type=template&id=c9b2e7e0&scoped=true"
import script from "./PlanCaseDetail.vue?vue&type=script&lang=js"
export * from "./PlanCaseDetail.vue?vue&type=script&lang=js"
import style0 from "./PlanCaseDetail.vue?vue&type=style&index=0&id=c9b2e7e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b2e7e0",
  null
  
)

export default component.exports